import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
export const API_BASE_URL = API;

const getApiOrigin = () => {
    const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : '';

    try {
        if (String(API).startsWith('/')) {
            return fallbackOrigin;
        }

        return new URL(API).origin;
    } catch (_error) {
        return fallbackOrigin;
    }
};

export const toAbsoluteApiUrl = (value = '') => {
    const rawValue = String(value || '').trim();
    if (!rawValue) {
        return '';
    }

    if (/^https?:\/\//i.test(rawValue)) {
        return rawValue;
    }

    const apiOrigin = getApiOrigin();
    if (!apiOrigin) {
        return rawValue;
    }

    if (rawValue.startsWith('/')) {
        return `${apiOrigin}${rawValue}`;
    }

    return `${apiOrigin}/${rawValue}`;
};

export const apiClient = axios.create({
    baseURL: API,
});

const normalizeErrorMessage = (rawMessage, fallback = 'Error de conexión con el servidor') => {
    if (!rawMessage) {
        return fallback;
    }

    if (typeof rawMessage === 'string') {
        return rawMessage;
    }

    if (Array.isArray(rawMessage)) {
        const normalized = rawMessage
            .map((item) => normalizeErrorMessage(item, ''))
            .filter(Boolean)
            .join(' | ');

        return normalized || fallback;
    }

    if (typeof rawMessage === 'object') {
        if (typeof rawMessage.msg === 'string' && rawMessage.msg.trim()) {
            return rawMessage.msg;
        }

        if (typeof rawMessage.message === 'string' && rawMessage.message.trim()) {
            return rawMessage.message;
        }

        const normalizedFields = Object.entries(rawMessage)
            .map(([field, value]) => {
                const fieldMessage = normalizeErrorMessage(value, '');
                if (!fieldMessage) {
                    return '';
                }

                return fieldMessage === String(value)
                    ? `${field}: ${fieldMessage}`
                    : fieldMessage;
            })
            .filter(Boolean)
            .join(' | ');

        if (normalizedFields) {
            return normalizedFields;
        }

        try {
            return JSON.stringify(rawMessage);
        } catch (_error) {
            return fallback;
        }
    }

    return String(rawMessage || fallback);
};

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const payload = error?.response?.data || {};

        return Promise.reject({
            success: false,
            ...payload,
            message: normalizeErrorMessage(payload.message, 'Error de conexión con el servidor'),
            status: error?.response?.status || 0,
        });
    }
);

export const apiRequest = async (config, fallbackMessage = 'Error de conexión con el servidor') => {
    try {
        const { data } = await apiClient(config);
        return data;
    } catch (error) {
        return {
            success: false,
            ...error,
            message: normalizeErrorMessage(error?.message, fallbackMessage),
        };
    }
};

export const withToken = (token) => ({
    'x-token': `${token}`,
});
